export default __webpack_public_path__ + "static/media/978.76928177.gif";